<!--
 * @Author: 陈远锋
 * @Date: 2022-03-07 15:26:22
 * @LastEditTime: 2025-12-03 17:35:00
 * @FilePath: \qyOut\src\pages\coupon\index.vue
 * @Description: Do not edit
-->
<template>
  <div>
    <Breadcrumb :style="{ margin: '20px 10px' }">
      <BreadcrumbItem>电子券管理</BreadcrumbItem>
      <BreadcrumbItem>订单列表</BreadcrumbItem>
    </Breadcrumb>
    <loading :loading="loading" :error="error"></loading>

    <Form ref="selectForm" :model="selectForm" inline>
      <FormItem prop="company">
        <dropdown
          @item-click="dropDownClick"
          :isNeedSearch="true"
          :companies="companies"
          :checkObjName="selectForm.company_name"
          style="width: 250px; margin-right: 10px; margin-left: 10px"
        ></dropdown>
      </FormItem>
      <FormItem prop="category_id">
        <Select
          v-model="selectForm.category_id"
          clearable
          multiple
          filterable
          style="width: 250px; margin-right: 10px; margin-left: 10px"
          @on-query-change="handleInput"
          @on-change="handleSelectChange"
          ref="select"
        >
          <Option
            v-for="category in categories"
            :value="category.category_id"
            :key="category.category_id"
            >{{ category.title }}</Option
          >
        </Select>
      </FormItem>
      <FormItem prop="alias">
        <Input v-model="selectForm.alias" placeholder="别名"></Input>
      </FormItem>
      <FormItem prop="id">
        <Input v-model="selectForm.id" placeholder="ID"></Input>
      </FormItem>
      <FormItem prop="voucher">
        <Input v-model="selectForm.voucher" placeholder="券码"></Input>
      </FormItem>
      <FormItem prop="business_id">
        <Input v-model="selectForm.business_id" placeholder="手机号"></Input>
      </FormItem>
      <FormItem prop="box_order_no">
        <Input
          v-model="selectForm.box_order_no"
          placeholder="三方订单号"
        ></Input>
      </FormItem>
      <FormItem prop="use_shop_name">
        <Input
          v-model="selectForm.use_shop_name"
          placeholder="核销站点"
        ></Input>
      </FormItem>
      <FormItem prop="use_shop_code">
        <Input
          v-model="selectForm.use_shop_code"
          placeholder="核销站点编码"
        ></Input>
      </FormItem>
      <FormItem prop="date">
        <DatePicker
          type="datetimerange"
          placeholder="时间范围"
          @on-change="handleDateChange"
          @on-clear="handleDateClear"
          style="width: 320px"
          v-model="selectedDateRange"
          format="yyyy-MM-dd HH:mm:ss"
        ></DatePicker>
      </FormItem>
      <FormItem>
        <Button type="primary" @click="goSelect()">查询</Button>
      </FormItem>
    </Form>
    <Table border stripe :columns="columns1" :data="coupons">
      <template slot-scope="{ row }" slot="alias">
        {{ row.coupon_categories && row.coupon_categories.title || '无' }}
      </template>
      <template slot-scope="{ row }" slot="is_reissue">
        <Tag :color="row.p_voucher ? 'green' : 'red'">
          {{ row.p_voucher ? '是' : '否' }}
        </Tag>
      </template>
      <template slot-scope="{ row }" slot="action"> 
        <Button
          type="primary"
          size="small"
          style="margin-right: 5px"
          @click="show(row)"
          >详情</Button
        >
        <Button
          type="primary"
          size="small"
          style="margin-right: 5px"
          @click="getState(row)"
          >获取状态</Button
        >
        <!-- 补发按钮 - 仅当状态为已过期(3)时显示 -->
        <Button
          v-if="row.status_id === 3"
          type="warning"
          size="small"
          style="margin-right: 5px"
          @click="handleReissue(row)"
          :loading="reissueLoading && reissuingItemId === row.id"
        >补发</Button
        >
      </template>
    </Table>
    <Page
      style="margin: 10px; text-align: center"
      show-total
      @on-change="pageOnChange"
      :total="pages.total"
      :current="pages.current_page"
      :page-size="pages.per_page"
      show-elevator
      prev-text="上一页"
      next-text="下一页"
    />
    
    <!-- 补发确认模态框 -->
    <Modal
      v-model="reissueModalVisible"
      title="确认补发"
      @on-ok="confirmReissue"
      @on-cancel="cancelReissue"
    >
      <p>确定要补发该电子券吗？</p>
      <p v-if="currentReissueItem" style="margin-top: 10px;">
        <strong>券码：</strong>{{ currentReissueItem.voucher }}<br>
        <strong>手机号：</strong>{{ currentReissueItem.business_id || '无' }}<br>
        <strong>状态：</strong>{{ currentReissueItem.status_desc || '已过期' }}
      </p>
    </Modal>
  </div>
</template>
<script>
import Dropdown from "../member/components/dropdown.vue";
import loading from "../loading.vue";
export default {
  components: { Dropdown, loading },
  data() {
    return {
      companies: [],
      categories: null,
      deleteModal: false,
      deleteObj: {
        id: 0,
      },
      loading: false,
      error: null,
      coupons: [],
      pages: {
        total: 0,
        path: "",
        links: [],
        current_page: 1,
        per_page: 20
      },
      selectForm: {
        company_id: "",
        company_name: "",
        category_id: "",
        alias: "",
        id: "",
        voucher: "",
        business_id: "",
        use_shop_name: "",
        use_shop_code: "",
        start_date: "",
        end_date: ""
      },
      columns1: [
        { align: "center", title: "ID", key: "id", minWidth: 100 },
        { align: "center", title: "客户ID", key: "gn_id", minWidth: 250 },
        { align: "center", title: "批次", key: "batch_no", minWidth: 180 },
        { align: "center", title: "券码", key: "voucher", minWidth: 200 },
        { align: "center", title: "名称", slot: "alias", minWidth: 200 },
        { align: "center", title: "手机号", key: "business_id", minWidth: 130 },
        { align: "center", title: "发券时间", key: "create_time", minWidth: 150 },
        { align: "center", title: "面值", key: "face_value", minWidth: 80 },
        { 
          align: "center", 
          title: "是否补发", 
          slot: "is_reissue", 
          minWidth: 100,
        },
        { align: "center", title: "补发原券码", key: "p_voucher", minWidth: 120 },
        {
          align: "center",
          title: "三方订单号",
          key: "box_order_no",
          minWidth: 250,
        },
        { align: "center", title: "状态", key: "status_desc", minWidth: 80 },
        {
          title: "操作",
          slot: "action",
          width: 300,
          align: "center",
        },
      ],
      copyValue: "",
      lastSearchQuery: "",
      selectedDateRange: [], // 绑定DatePicker选中值
      // 补发相关
      reissueModalVisible: false,
      currentReissueItem: null,
      reissueLoading: false,
      reissuingItemId: null
    };
  },
  created() {
    // 初始化默认时间范围（近5个月，起止时间为23:00:00）
    const defaultDateRange = this.getDefaultDateRange();
    this.selectedDateRange = [defaultDateRange.startDate, defaultDateRange.endDate];
    this.selectForm.start_date = defaultDateRange.startDateStr;
    this.selectForm.end_date = defaultDateRange.endDateStr;
    
    if (this.$route.params.page) {
      let url = "coupons/list?page=" + this.$route.params.page;
      delete this.$route.params.page;
      this.selectForm = { ...this.selectForm, ...this.$route.params };
    
      if (this.$route.params.start_date && this.$route.params.end_date) {
        const startDate = new Date(this.$route.params.start_date);
        const endDate = new Date(this.$route.params.end_date);
        this.selectedDateRange = [startDate, endDate];
      }
      
      this.fetchData(url, this.selectForm);
    } else {
      // 初始加载近5个月数据
      this.fetchData("coupons/list", {
        ...this.selectForm,
        start_date: defaultDateRange.startDateStr,
        end_date: defaultDateRange.endDateStr
      });
    }
    
    // 获取公司列表
    this.axios.get("company").then((res) => {
      console.log("公司列表res", res);
      this.companies = res.data.companies || [];
      this.loading = false;
    }).catch(() => { 
      this.error = "获取公司列表失败";
      this.loading = false;
    });
    
    // 获取券分类列表
    this.axios.get("couponCategories/totalList").then((res) => {
      console.log("券分类列表res", res);
      this.categories = res.data.coupon_categories || [];
      this.loading = false;
    }).catch(() => { 
      this.error = "获取券分类列表失败";
      this.loading = false;
    });
  },
  methods: {
    // 获取默认时间范围（近5个月，起止时间设为23:00:00）
    getDefaultDateRange() {
      // 结束时间：当前日期的23:00:00
      const endDate = new Date(); 
      endDate.setHours(23, 0, 0, 0); // 设置为23:00:00
      
      // 开始时间：5个月前的同一天23:00:00
      const startDate = new Date();
      startDate.setMonth(endDate.getMonth() - 5); // 改为5个月前
      startDate.setHours(23, 0, 0, 0); // 设置为23:00:00
      
      return {
        startDate,
        endDate,
        startDateStr: this.formatDate(startDate),
        endDateStr: this.formatDate(endDate)
      };
    },
    
    // 时间格式化
    formatDate(date) {
      if (typeof date === 'string') {
        date = new Date(date);
      }
      
      if (!(date instanceof Date) || isNaN(date.getTime())) {
        return '';
      }
      
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    
    // 将值转换为Date对象
    ensureDateObject(dateValue) {
      if (!dateValue) return null;
    
      if (dateValue instanceof Date) {
        return dateValue;
      }
      
      if (typeof dateValue === 'string') {
        const date = new Date(dateValue);
        return isNaN(date.getTime()) ? null : date;
      }
      
      return null;
    },
    
    // 搜索框输入事件
    handleInput(e) {
      this.lastSearchQuery = e;
    },
    
    // 选择器变化事件
    handleSelectChange() {
      let input = this.lastSearchQuery;
      setTimeout(() => {
        if (this.$refs.select) {
          this.$refs.select.setQuery(input);
        }
      }, 300);
    },
    
    // 点击查询
    goSelect() {
      this.updateFormDateParams();
      this.fetchData("coupons/list", this.selectForm);
    },
  
    updateFormDateParams() {
      if (this.selectedDateRange && this.selectedDateRange.length === 2) {
        const startDate = this.ensureDateObject(this.selectedDateRange[0]);
        const endDate = this.ensureDateObject(this.selectedDateRange[1]);
        
        if (startDate && endDate) {
          // 强制将选中的时间设为23:00:00
          startDate.setHours(23, 0, 0, 0);
          endDate.setHours(23, 0, 0, 0);
          
          this.selectForm.start_date = this.formatDate(startDate);
          this.selectForm.end_date = this.formatDate(endDate);
          return;
        }
      }
      this.selectForm.start_date = "";
      this.selectForm.end_date = "";
    },
    
    // 分页变化
    pageOnChange(page) {
      this.updateFormDateParams();
      
      let targetUrl = "";
      const targetLink = this.pages.links.find(link => link.label === page);
      if (targetLink) {
        targetUrl = targetLink.url;
      } else {
        targetUrl = this.pages.path.indexOf("?") > 0
          ? `${this.pages.path}&page=${page}`
          : `${this.pages.path}?page=${page}`;
      }
      this.fetchData(targetUrl, this.selectForm);
    },
    
    // 时间范围变化
    handleDateChange(date) {
      this.selectedDateRange = date;
      this.updateFormDateParams();
      // 自动触发查询
      this.fetchData("coupons/list", this.selectForm);
    },
    
    // 时间清空
    handleDateClear() {
      this.selectedDateRange = [];
      
      // 清空表单中的时间参数
      this.selectForm.start_date = "";
      this.selectForm.end_date = "";
      
      this.fetchData("coupons/list", this.selectForm);
    },
    
    // 获取数据列表
    fetchData(url = "coupons/list", params = {}) {
      this.loading = true;
      this.error = null;
      const filteredParams = {};
      for (let key in params) {
        if (params[key] !== undefined && params[key] !== null && params[key] !== "") {
          if (Array.isArray(params[key]) && params[key].length === 0) {
            continue;
          }
          filteredParams[key] = params[key];
        }
      }
      
      this.axios.get(url, { params: filteredParams }).then((res) => {
        console.log("券列表res", res);
        this.coupons = res.data.coupons || [];
        this.pages = { ...this.pages, ...res.data.meta };
        this.loading = false;
      }).catch(err => {
        this.error = err.message || "获取数据失败";
        this.loading = false;
        this.coupons = [];
      });
    },
    
    // 公司选择下拉框事件
    dropDownClick(e) {
      this.selectForm.company_id = e.id;
      this.selectForm.company_name = e.company_name;
    },
    
    // 查看详情
    show(row) {
      console.log("详情row", row);
      this.updateFormDateParams();
      const params = { ...this.selectForm, page: this.pages.current_page };
      this.$router.push({
        path: `/pages/coupon_detail/${row.id}`,
        query: params
      });
    },
    
    // 获取状态
    getState(row) {
      this.axios.get(`coupons/getState/${row.id}`).then((res) => {
        console.log("获取状态res", res);
        this.$Message.success("操作成功");
        // 刷新当前页数据
        this.fetchData(this.pages.path || "coupons/list", this.selectForm);
      }).catch(err => {
        this.$Message.error(err.message || "操作失败");
      });
    },
    
    // 补发操作
    handleReissue(row) {
      this.currentReissueItem = row;
      this.reissueModalVisible = true;
    },
    
    // 确认补发
    confirmReissue() {
      if (!this.currentReissueItem) return;
      
      this.reissueLoading = true;
      this.reissuingItemId = this.currentReissueItem.id;
      
      this.axios.get(`coupons/reissueCoupon/${this.currentReissueItem.id}`)
        .then((res) => {
          console.log("补发成功res", res);
          this.$Message.success("补发成功");
          
          // 刷新当前页数据
          this.fetchData("coupons/list", this.selectForm);
          
          this.reissueModalVisible = false;
          this.currentReissueItem = null;
          this.reissueLoading = false;
          this.reissuingItemId = null;
        })
        .catch(err => {
          console.error("补发失败", err);
          this.$Message.error(err.message || "补发失败，请重试");
          this.reissueLoading = false;
          this.reissuingItemId = null;
        });
    },
    
    // 取消补发
    cancelReissue() {
      this.reissueModalVisible = false;
      this.currentReissueItem = null;
    }
  }
};
</script>